var map = {
	"./horse-1.png": 70131,
	"./horse-2.png": 74979,
	"./horse-3.png": 57081,
	"./horse-4.png": 23956,
	"./horse-5.png": 72140,
	"./horse-6.png": 68610,
	"./horse-7.png": 18970,
	"./horse-8.png": 78044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32253;